import {
  ListContextProvider,
  ResourceContextProvider,
  useList,
  useTranslate,
} from "ra-core";

import { cn } from "@/lib/utils";

import { TasksIterator } from "./TasksIterator";

type TaskListProps = {
  tasks: any[];
  title: string;
  showContact?: boolean;
  isMobile: boolean;
  /** red-tinted group with a dot, as overdue rows on the dashboard (static) */
  overdue?: boolean;
};

export const TaskListFilter = ({
  tasks,
  title,
  showContact,
  isMobile,
  overdue = false,
}: TaskListProps) => {
  const translate = useTranslate();
  const listContext = useList({
    data: tasks,
    resource: "tasks",
    perPage: isMobile ? 10 : 5,
  });

  const { total } = listContext;

  if (!tasks?.length || !total) return null;

  return (
    <div
      className={cn(
        "flex flex-col gap-2",
        overdue &&
          "-mx-2 px-2 py-2 rounded-lg bg-destructive/5 border border-destructive/30",
      )}
      data-overdue={overdue || undefined}
    >
      <p
        className={cn(
          "vv-heading mb-2 flex items-center gap-2",
          overdue && "text-destructive",
        )}
      >
        {overdue ? (
          <span className="size-1.5 rounded-full bg-destructive" aria-hidden />
        ) : null}
        {title}
      </p>
      <ResourceContextProvider value="tasks">
        <ListContextProvider value={listContext}>
          <TasksIterator showContact={showContact} />
        </ListContextProvider>
      </ResourceContextProvider>
      {total > listContext.perPage && (
        <div className="flex justify-center">
          <a
            href="#"
            onClick={(e) => {
              listContext.setPerPage(listContext.perPage + 10);
              e.preventDefault();
            }}
            className="text-sm underline hover:no-underline"
          >
            {translate("crm.common.load_more")}
          </a>
        </div>
      )}
    </div>
  );
};
